const initials = "subject/";

export const UPDATE_SUBJECT_LIST = `${initials}UPDATE_SUBJECT_LIST`;